import { SegmentedTabs } from "@/components/ui/segmented-tabs";
import { STATS_TIME_PERIOD_LABELS, type StatsTimePeriod } from "@/services/api/guardiansv2/types";

export interface StatsToolbarControlsProps {
  timePeriod: StatsTimePeriod;
  onTimePeriodChange: (period: StatsTimePeriod) => void;
}

const PERIODS: StatsTimePeriod[] = ["1w", "1m", "3m", "all"];

const PERIOD_TABS = PERIODS.map((period) => ({
  id: period,
  label: STATS_TIME_PERIOD_LABELS[period],
}));

export function StatsToolbarControls({ timePeriod, onTimePeriodChange }: StatsToolbarControlsProps) {
  return (
    <div className="flex w-full items-center px-1 py-1" data-testid="stats-toolbar-controls">
      <SegmentedTabs
        tabs={PERIOD_TABS}
        activeId={timePeriod}
        showDivider={false}
        tabTestIdPrefix="stats-period"
        onChange={(id) => {
          if ((PERIODS as readonly string[]).includes(id)) {
            onTimePeriodChange(id as StatsTimePeriod);
          }
        }}
      />
    </div>
  );
}
